import { differenceInCalendarDays, format, isSameYear } from 'date-fns'

// Moment's `calendar()` bucketed a date by its distance in calendar days from
// today: 0/±1 got their own words, ±2 to ±6 got a plain date, and anything 7 or
// more days out fell through to the general case. These two helpers keep those
// buckets.
const TODAY = 0
const TOMORROW = 1
const YESTERDAY = -1
const WITHIN_A_WEEK = 6

export const getDueDateLabel = (dueDate: Date, newTodos?: boolean) => {
  const now = new Date()
  const dayDiff = differenceInCalendarDays(dueDate, now)

  if (dayDiff === TODAY) return 'Today'
  if (dayDiff === TOMORROW) return 'Tomorrow'
  if (dayDiff === YESTERDAY) return 'Yesterday'
  if (newTodos || Math.abs(dayDiff) <= WITHIN_A_WEEK) return format(dueDate, 'MMM d, yyyy')
  return isSameYear(dueDate, now)
    ? format(dueDate, 'EEE, MMM d')
    : format(dueDate, 'EEE, MMM d yyyy')
}

export const getUpdatedAtLabel = (dueDate: Date) => {
  const dayDiff = differenceInCalendarDays(dueDate, new Date())
  const time = format(dueDate, 'h:mm a')

  if (dayDiff === TODAY) return `Today, ${time}`
  if (dayDiff === TOMORROW) return `Tomorrow, ${time}`
  if (dayDiff === YESTERDAY) return `Yesterday, ${time}`
  return `${format(dueDate, 'MMM d, yyyy')} ${time}`
}
